
import Welcome from "./pages/home/welcome/Welcome"
import Login from "./pages/login/Login"
import Selection from "./pages/selection/Selection"
import Signup from  "./pages/signup/Signup"
import Raml from "./pages/raml/Raml"
import RamlPic from "./pages/ramlpic/RamlPic"
import RamlCircle from "./pages/ramlcircle/RamlCircle"
import Adminn from "./pages/admin/Adminn"
import CircleList from "./pages/circlelist/CircleList"
import AddCirclePage from "./pages/addcirclepage/AddCirclePage"
import SelectRaml from "./pages/selectraml/SelectRaml"
import Question from "./pages/question/Question"
import RamlNazar from "./pages/ramlnazar/RamlNazar"
import RamlJadval from "./pages/ramlJadval/RamlJadval"
import ProtectedRoute from "./utils/ProtectedRoute"


let routes=[
    {path:'/',element:<Welcome/>},
{path:'/login',element:<Login/>},
{path:'/signup',element:<Signup/>},
// {path:'/raml',element:<Raml/>},
{path:'/selection',element:<ProtectedRoute element={<Selection/>}/>},
{path:'/raml',element:<ProtectedRoute element={<Raml/>} />},
{path:'/ramlpic',element:<ProtectedRoute element={<RamlPic/>}/>},
{path:'/ramlcircle',element:<ProtectedRoute element={<RamlCircle/>}/>},
{path:'/admin',element:<ProtectedRoute element={<Adminn/>}/>},
{path:'/circlelist',element:<ProtectedRoute element={<CircleList/>}/>},
{path:'/addcircle',element:<ProtectedRoute element={<AddCirclePage/>}/>},
{path:'/selectraml',element:<ProtectedRoute element={<SelectRaml/>}/>},
{path:'/question',element:<ProtectedRoute element={<Question/>}/>},
{path:'/RamlNazar',element:<ProtectedRoute element={<RamlNazar/>}/>},
{path:'/RamlJadval',element:<ProtectedRoute element={<RamlJadval/>}/>},
]





export default routes

